import React, { useState } from 'react';
import axios from "axios";

const PdfToText = () => {
    const [pdfFile, setPdfFile] = useState(null);
    const [extractedText, setExtractedText] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [isCopySuccess, setIsCopySuccess] = useState(false);

    const handleFileChange = (event) => {
        if (pdfFile) {
            setPdfFile(null);
        };
        const file = event.target.files[0];
        setPdfFile(file);
    };

    const handleExtractText = async () => {
        setIsUploading(true);

        const formData = new FormData();
        formData.append('file', pdfFile);
        formData.append('page', '1');

        const options = {
            method: 'POST',
            url: 'https://pdf-to-text-converter.p.rapidapi.com/api/pdf-to-text/convert',
            headers: {
                'X-RapidAPI-Key': 'pdf-to-text-converter-api key from rapid api',
                'X-RapidAPI-Host': 'pdf-to-text-converter.p.rapidapi.com',
            },
            data: formData,
        };

        try {
            const response = await axios.request(options);
            setExtractedText(response.data);
            setPdfFile(null);
            setIsUploading(false);
        } catch (error) {
            console.error('Error extracting text:', error);
        } finally {
            setPdfFile(null);
            setIsUploading(false);
        }
    };

    const handleCopyText = () => {
        navigator.clipboard.writeText(extractedText);
        setIsCopySuccess(true);
        setTimeout(() => {
            setIsCopySuccess(false);
        }, 3000);
    };

    const handleDownloadTextFile = () => {
        const blob = new Blob([extractedText], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'extracted_text.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="p-8 text-center bg-gradient w-full font-primary mb-10">
            <div className="absolute top-0 left-[55%] overlay-glow2"></div>
            <div className="mb-8 w-[70%] mx-auto">
                <label
                    className="mb-4 inline-block text-neutral-700 dark:text-neutral-200 text-4xl text-light text-center font-bold my-3"
                    htmlFor="pdfFile"
                >
                    Choose PDF File
                </label>
                <input
                    className="relative m-0 block w-full min-w-0 flex-auto cursor-pointer rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] font-normal leading-[2.15] text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:cursor-pointer file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                    type="file"
                    id="pdfFile"
                    accept=".pdf"
                    onChange={handleFileChange}
                    disabled={isUploading}
                />
            </div>

            <button
                className="text-white p-4 rounded-md mb-8 primary-color disabled:cursor-wait font-semibold"
                onClick={handleExtractText}
                disabled={!pdfFile || isUploading}
            >
                {isUploading ? "Extracting..." : "Extract Text"}
            </button>

            <div className="bg-gray-100 p-8 mb-8 text-left rounded-md w-[85%] mx-auto">
                <div className="mb-4">
                    <label className="mr-2 font-semibold">Extracted Text:</label>
                    <div
                        className={`border border-[#ad53e5] p-4 rounded-md h-40 overflow-auto ${isCopySuccess ? 'bg-green-100' : ''
                            }`}
                    >
                        {extractedText}
                    </div>
                    <div className="flex flex-row gap-2">
                        <button
                            onClick={handleCopyText}
                            className={`text-white bg-blue-500 px-4 py-2 rounded-md mt-4 ${isCopySuccess ? 'cursor-not-allowed' : 'cursor-pointer'
                                }`}
                            disabled={isCopySuccess}
                        >
                            {isCopySuccess ? 'Copied!' : 'Copy Text'}
                        </button>
                        <button
                            onClick={handleDownloadTextFile}
                            className={`text-white bg-green-500 px-4 py-2 rounded-md mt-4 ${isCopySuccess ? 'cursor-not-allowed' : 'cursor-pointer'
                                }`}
                            disabled={!extractedText || isUploading}
                        >
                            Download as Text
                        </button>
                    </div>
                </div>
            </div>

            {isUploading && <div className="text-gray-500">Extracting text...</div>}
        </div>
    );
};

export default PdfToText;
